import React from 'react';
import { IconButtonRecording } from '../../../components/UI/Buttons';
import { hasPastMovieProgramPlaybackOption } from '../../../queries/ats/playback/utils';
import { RecordButton, RecordButtonProps } from '../details-button/record-button';
import { DetailsDataProvider } from '../details-data-provider/details-data-provider';

interface StandaloneRecordButtonProps extends Pick<RecordButtonProps, 'children'> {
  programId: string;
}

export function StandaloneRecordButton({ children, programId }: StandaloneRecordButtonProps) {
  return (
    <DetailsDataProvider
      type="program"
      id={programId}
      skeleton={<IconButtonRecording />}
      fallback={null}
      orderByProviderId={undefined}
      orderByServiceType={undefined}
    >
      {({ focusedAsset, source }) => {
        if (source.type !== 'program') {
          throw new Error('Expected program source');
        }
        if (focusedAsset.type === 'movie') {
          if (hasPastMovieProgramPlaybackOption(focusedAsset)) {
            return <></>;
          }
        }
        return (
          <RecordButton asset={focusedAsset} source={source}>
            {children}
          </RecordButton>
        );
      }}
    </DetailsDataProvider>
  );
}
